import React from 'react';
import { DateFormatter, DateFormatTypes } from '@vp/om-date-formatter';
import dayjs from 'dayjs';
import { isString } from 'lodash';
import useSiteData from '../../hooks/useSiteData';
import { trackInvalidDateStringProvided } from '../../apis/newRelicTrackingApi';
import useIdentityContext from '../../hooks/useIdentityContext';

/**
 * Wrapper function to render dates in the UI. Expects date prop to be valid date string. If invalid type provided, we fire a metric and alert on this metric.
 * In the case of an invalid date type, we return null rather than throwing an error so the page rendering this component does not blow up
 *
 * @param date
 * @param dateFormatType
 * @returns {JSX.Element|null}
 * @constructor
 */
type DateProps = {
  date: string;
  dateFormatType?: DateFormatTypes;
};

const Date = ({
  date,
  dateFormatType = DateFormatTypes.SHORT_FMT,
}: DateProps) => {
  const { identity } = useIdentityContext();
  const { shopperId, anonymousUserId } = identity;
  const shopperIdentifier = shopperId || anonymousUserId;

  const { locale } = useSiteData();

  if (!isString(date) || !dayjs(date).isValid()) {
    const error = new Error('date prop provided is not a valid date string');
    trackInvalidDateStringProvided(error, shopperIdentifier, {
      invalidDate: date,
    });

    // don't render anything if date format is invalid.
    return null;
  }
  return (
    <DateFormatter date={date} locale={locale} formatType={dateFormatType} />
  );
};

export default Date;
